// src/utils/enums.js

export const Role = {
  Admin: 10,
  AdminPendingVerification: 9, // Added
  Seller: 5,
  SellerPendingVerification: 4, // Added
  User: 2,
  UserPendingVerification: 1, // Added
  Guest: 0,
};

// Numeric values for PropertyType, matching backend `PropertyType` enum
export const PropertyTypeNumericBE = {
  SingleFamily: 0,
  MultiFamily: 1,
  Apartment: 2,
  Townhouse: 3,
  MobileHome: 4, // Corresponds to 'Mobile-home'
  VacationHome: 5, // Corresponds to 'Vacation-home'
};

// Map from string values (used in forms/frontend) to numeric backend values
// This should align with backend's `PropertyTypeMap`
export const PropertyTypeStringToNumericMap = {
  'Single-family': PropertyTypeNumericBE.SingleFamily,
  'Multi-family': PropertyTypeNumericBE.MultiFamily,
  Apartment: PropertyTypeNumericBE.Apartment,
  Townhouse: PropertyTypeNumericBE.Townhouse,
  'Mobile-home': PropertyTypeNumericBE.MobileHome,
  'Vacation-home': PropertyTypeNumericBE.VacationHome,
};

// Map from numeric backend values to string values for frontend display
export const PropertyTypeNumericToStringMap = Object.fromEntries(Object.entries(PropertyTypeStringToNumericMap).map(([key, value]) => [value, key]));

// For dropdowns in PropertyFields.js, using string values that backend expects.
// These keys MUST match the keys in backend's PropertyTypeMap.
// Display labels can be customized here if needed (e.g., 'Mobile Home' instead of 'Mobile-home').
export const PropertyTypeLabels = {
  'Single-family': 'Single-family',
  'Multi-family': 'Multi-family',
  Apartment: 'Apartment',
  Townhouse: 'Townhouse',
  'Mobile-home': 'Mobile Home',
  'Vacation-home': 'Vacation Home',
};

// Array for select options, value should be the key that backend PropertyTypeMap expects
export const PropertyTypeOptions = Object.entries(PropertyTypeLabels).map(([value, label]) => ({
  value, // e.g., 'Single-family'
  label, // e.g., 'Single-family' or 'Mobile Home' for display
}));

// Corresponds to PropertyStatus in backend models/enums.js
export const PropertyStatusNumeric = {
  ForSale: 0,
  Pending: 1,
  Sold: 2,
  Hide: 3,
};

// Array for select options, mapping numeric value to a display label
export const PropertyStatusOptions = Object.entries(PropertyStatusNumeric).map(([key, value]) => ({
  value: value, // Numeric value for the form (e.g., 0)
  label: key.replace(/([A-Z])/g, ' $1').trim(), // Converts 'ForSale' to 'For Sale'
}));
